var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustry(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.344 16.6H3.658a.663.663 0 01-.63-.7L3 4.688A.675.675 0 013.658 4H6.72a.675.675 0 01.656.689v5.641l3.804-2.55a.628.628 0 01.35-.108.676.676 0 01.658.69v1.96l3.831-2.542a.621.621 0 01.345-.108.666.666 0 01.635.696v7.531a.68.68 0 01-.655.7zm-3.907-4.2v1.25h1.191V12.4h-1.191zm-2.633 0v1.25h1.191V12.4H9.804zm-2.646 0v1.25h1.19V12.4h-1.19z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default ForwardRef;